import { useQuery } from 'react-query';

import { PlanGroup } from '@d-id/types';

import { priceCreditsClaimsKey, stripePriceIdClaimsKey } from '@/environment';
import { useAnalytics } from '@/services/analytics';
import { Billing } from '@/services/api';
import { useAuth } from '@/services/auth';
import { logger } from '@/services/logger';
import { useCreditQuery } from '@/state/credits/credits';

export default function (requestedPriceId?: string, requestedPlan?: PlanGroup, requestedBilling?: Billing) {
    const { getAccessTokenSilently, getIdTokenClaims, user, setUser } = useAuth();
    const { refetch: refetchCredits } = useCreditQuery();
    const mixpanel = useAnalytics();

    return useQuery(
        'get-new-plan',
        async () => {
            await getAccessTokenSilently(true);
            const claims = await getIdTokenClaims();
            return claims?.[stripePriceIdClaimsKey] === requestedPriceId
                ? Promise.resolve()
                : Promise.reject('Timed out fetching new plan');
        },
        {
            retry: 5,
            retryDelay: 1000,
            refetchOnWindowFocus: false,
            onSuccess: async () => {
                const claims = await getIdTokenClaims();
                const priceCredits = claims?.[priceCreditsClaimsKey];
                setUser({ ...user!, priceCredits, planGroup: requestedPlan, billingInterval: requestedBilling, priceId: requestedPriceId });
                setTimeout(() => {
                    // wait for mixpanel to be updated after setUser before sending the event
                    mixpanel?.track('post-checkout', {
                        status: 'success',
                        requestedPlan,
                        requestedBilling,
                    });
                }, 3000);
                refetchCredits();
            },
            onError: e => {
                logger.error('Failed to get new plan', e);
                mixpanel?.track('post-checkout', {
                    status: 'fail',
                    requestedPlan,
                    requestedBilling,
                    error: e,
                });
            },
        }
    );
}
